import React from 'react';
import PropType from 'prop-types';
import themeable from 'zignal-landscape/lib/themeable';
import ToolTip from 'zignal-landscape/lib/ToolTip';

const TooltipSideBar = ({
  styles,
  item,
}) => {
  const toolTipContent = (
    <div className={styles.tooltipContainer} data-cy="tooltip-content">
      <div
        className={`${styles.tooltipTitleFont} ${styles.tooltipTitle}}`}
      >
        {item.title}
      </div>
      <hr className={styles.tooltipResetMarginPadding} />
      <p className={styles.tooltipContent}>
        {item.tooltip}
      </p>
    </div>
  );
  return (
    // tooltipText is the tooltip content
    // the children is the element that on hover shows the tooltip.
    <ToolTip
      position="right"
      tooltipText={toolTipContent}
      className={styles.tooltipResetMarginPadding}
    >
      <div className={styles.tooltipTitleFont} data-cy="tooltip-title">
        {item.title}
      </div>
    </ToolTip>
  );
};


TooltipSideBar.propTypes = {
  styles: PropType.object.isRequired,
  item: PropType.object.isRequired
};

export default themeable(TooltipSideBar);
